export const SILVERADO_RESORT_DEFAULTS = {
  emailTitle: 'Napa Is Waiting For You',
  ctaText: 'Book Now',
  ctaBackgroundColor: '#1e4b7a',
  ctaTextColor: '#ffffff',
  logoWidth: '120px',
  logoHeight: '120px',
  footerLogoWidth: '120px',
  galleryKicker: '',
  galleryTitle: 'Discover Silverado',
  discoverIntroText:
    'This is your open invitation to stop dreaming and start doing with the endless possibilities here at Silverado Resort.',
  discoverBtn1: 'Explore Flavors',
  discoverBtn2: 'Experience Events',
  discoverBtn3: 'Celebrate Birdies',
  discoverBtn4: 'Discover Tranquility',
  hotelPhone: '(800) 532-0500',
  hotelWebsite: 'silveradoresort.com',
  hotelWebsiteUrl: 'https://silveradoresort.com',
  richtextFields: {
    bodyHtml: `Dear :token{key="guestName" label="First name"},

Still interested in exploring the beauty and bounty of Napa Valley? Book your dates for an unforgettable getaway while they're still available, and be sure to take advantage of our latest **special offers and seasonal packages**.

Check In Date: :token{key="checkinDate" label="Check-in date"}`
  }
}

export default SILVERADO_RESORT_DEFAULTS
